import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { usePostTopicList } from '@/store';

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
};

export const TopicSelector: React.FC<Props> = ({ value, onChange }) => {
  const { postTopics = [], isPending } = usePostTopicList();
  const { t } = useTranslation('StudentDashboardTranslations');
  const options = postTopics.map(topic => ({
    label: topic.name,
    value: topic._id
  }));

  const handleChange = (newValue?: string) => {
    onChange?.(newValue);
  };

  return (
    <Select
      showSearch
      allowClear
      value={value}
      options={options}
      onChange={handleChange}
      loading={isPending}
      placeholder={t('ALL_TOPICS')}
      style={{ minWidth: '150px' }}
      variant="borderless"
      size="small"
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};
